import AwesomeDebouncePromise from 'awesome-debounce-promise'

import { useCallback, useState } from 'react'
import { useAsyncAbortable } from 'react-async-hook'

import isEmpty from 'lodash/fp/isEmpty'

export default function useSearch<T>(
  searchCallback: (
    search: string,
    abortSignal: AbortSignal,
  ) => Promise<Array<T>>,
  debounceDelay: number = 300,
) {
  const [searchTerm, setSearchTerm] = useState<string>('')

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearchCallback = useCallback(
    AwesomeDebouncePromise(searchCallback, debounceDelay),
    [searchCallback, debounceDelay],
  )

  const searchResults = useAsyncAbortable(
    async (abortSignal, search) => {
      if (isEmpty(search)) {
        return []
      }

      return debouncedSearchCallback(search, abortSignal)
    },
    [searchTerm],
  )

  return [searchTerm, setSearchTerm, searchResults] as const
}
